// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detail-section[data-v-a122eb26] {\n  padding-inline: 0;\n  padding-top: 8px;\n  padding-bottom: 16px;\n}\n.detail[data-v-a122eb26] {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n.detail__field[data-v-a122eb26] {\n  min-width: 0;\n}\n", ""]);
// Exports
module.exports = exports;
